import { Divider, Space } from 'component/Space'
import { Typo } from 'component/Typo'
import { i18n } from 'i18n'
import { observer } from 'mobx-react-lite'

export const Or = observer(() => {
  return (
    <Space gap={16} pad={[0, 8]} height={16} center>
      <Divider />
      <Typo size={16} one medium upper>
        {i18n('DividerOr')}
      </Typo>
      <Divider />
    </Space>
  )
})
